import { DeleteOutline } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import moment from "moment";

export const DashboardTableColumn = (view: any, onDelete: (row: any) => void, isInternal: boolean, getPath: (id: string) => string) => ([
    {
        field: 'sequence_id', headerName: 'Search Prompt Id', width: 180, renderCell: (params: GridRenderCellParams) => {
            return <Typography
                onClick={(e) => {
                    e.preventDefault();
                    view(params.row)
                }}
                variant="body2"
                component={"a"}
                href={getPath(params.row?._id)}
                color={"primary"}
                sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", textDecoration: "underline" }}>
                {params.row.sequence_id}
            </Typography>
        }
    },
    {
        field: 'name', headerName: 'Name', width: 200, renderCell: (params: GridRenderCellParams) => {
            return <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{params.row.name}</Typography>
        }
    },
    {
        field: 'description', headerName: 'Description', width: 200, renderCell: (params: GridRenderCellParams) => {
            return <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{params.row.description}</Typography>
        }
    },
    {
        field: 'prompt_text', headerName: 'Prompt Text', width: 300, renderCell: (params: GridRenderCellParams) => {
            return <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{params.row.prompt_text}</Typography>
        }
    },
    { field: 'created_user', headerName: 'Created By', width: 150 },
    {
        field: 'created_time', headerName: 'Created At', width: 250, renderCell: (params: GridRenderCellParams) => {
            return <Typography variant="body2">{moment(params.row.created_time).format('lll')}</Typography>
        }
    },
    { field: 'modified_user', headerName: 'Uploaded By', width: 150 },
    {
        field: 'modified_time', headerName: 'Uploaded At', width: 250, renderCell: (params: GridRenderCellParams) => {
            return <Typography variant="body2">{moment(params.row.modified_time).format('lll')}</Typography>
        }
    },
    {
        field: 'delete', headerName: 'Delete', width: 100, renderCell: (params: GridRenderCellParams) => {
            return <IconButton onClick={() => onDelete(params.row)}>
                <DeleteOutline color={"error"} />
            </IconButton>
        },
        disableColumnMenu: true,
        sortable: false,
    }
]);